var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-list-group-item',{attrs:{"to":{
    name: 'EditDeck',
    params: { id: _vm.notification.target_id },
    hash: ("#comment-" + (_vm.notification.trigger_id)),
  }}},[_c('font-awesome-icon',{staticClass:"mr-1 text-warning",attrs:{"icon":_vm.icon}}),_vm._v(" "+_vm._s(_vm.message)+" "),_c('span',[_vm._v(_vm._s(_vm.notification.target_name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }